module.exports = __webpack_public_path__ + "static/img/600x600-HOME-4.e357e7ef.jpg";